import { render, staticRenderFns } from "./vCodes.vue?vue&type=template&id=2763f7e8&scoped=true"
import script from "./vCodes.vue?vue&type=script&lang=js"
export * from "./vCodes.vue?vue&type=script&lang=js"
import style0 from "./vCodes.vue?vue&type=style&index=0&id=2763f7e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2763f7e8",
  null
  
)

export default component.exports